/* ===================================================
   くじらマットレス LP — Interactive Logic
=================================================== */

(function () {
  'use strict';

  /* ── Firmness Diagnosis ── */
  const MATTRESS = [
    // [0] センターハード (no悩み)
    [[70,240,70,150,150,150],[70,240,150,150,70,150],[70,150,70,150,240,150],[70,70,150,150,240,150],[70,70,150,150,150,240]],
    // [1] センターハード (腰痛・肩こり)
    [[70,240,70,150,150,150],[70,240,150,150,70,150],[70,150,70,150,240,150],[70,70,150,150,240,150],[70,70,150,150,150,240]],
    // [2] 横向き寝
    [[70,240,150,70,150,150],[70,70,150,150,240,150],[70,70,150,150,150,240],[70,150,150,70,240,150],[70,150,150,70,150,240]],
    // [3] 反り腰対策
    [[70,150,240,70,150,150],[70,150,150,70,150,240],[70,70,150,150,240,150],[70,70,240,150,150,150],[70,70,150,150,150,240]],
    // [4] 柔らかめ好き
    [[70,70,150,150,240,150],[70,70,150,150,240,150],[70,70,150,150,150,240],[70,70,150,150,150,240],[70,70,150,150,150,240]]
  ];

  const NAYAMI_LABELS = {
    no: '特になし', pain: '腰痛・肩こり対策',
    yokomuki: '横向き寝中心', sorigoshi: '反り腰', soft: '柔らかめが好き'
  };

  function calcDiagnosis(height, weight, sex, nayami) {
    const bmi = weight / Math.pow(height / 100, 2) + (sex === 'female' ? 0 : -1);
    let h;
    if (bmi < 16) h = 4;
    else if (bmi < 18.5) h = 3;
    else if (bmi < 23) h = 2;
    else if (bmi < 28) h = 1;
    else h = 0;
    const ni = { no: 0, pain: 1, yokomuki: 2, sorigoshi: 3, soft: 4 }[nayami] ?? 0;
    return MATTRESS[ni][h];
  }

  function openQuiz() {
    renderDiagForm();
    document.getElementById('klp-quiz-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'diagnosis_start' });
  }

  function closeQuiz() {
    document.getElementById('klp-quiz-overlay').classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderDiagForm() {
    const overlay = document.getElementById('klp-quiz-overlay');
    if (!overlay) return;
    overlay.querySelector('.klp-quiz-step-label').textContent = '硬さ診断';
    overlay.querySelector('.klp-quiz-progress').style.display = 'none';
    const heights = [];
    for (let h = 140; h <= 200; h += 5) heights.push(h);
    const weights = [];
    for (let w = 40; w <= 130; w += 5) weights.push(w);

    overlay.querySelector('.klp-quiz-body').innerHTML = `
      <p class="klp-quiz-q">身長・体重・性別・お悩みを<br>選択してください。</p>
      <div class="klp-diag-form">
        <div class="klp-diag-field">
          <label class="klp-diag-field-label" for="klp-d-height">身長</label>
          <select class="klp-diag-select" id="klp-d-height">
            ${heights.map(h => `<option value="${h}"${h === 165 ? ' selected' : ''}>${h} cm</option>`).join('')}
          </select>
        </div>
        <div class="klp-diag-field">
          <label class="klp-diag-field-label" for="klp-d-weight">体重</label>
          <select class="klp-diag-select" id="klp-d-weight">
            ${weights.map(w => `<option value="${w}"${w === 60 ? ' selected' : ''}>${w} kg</option>`).join('')}
          </select>
        </div>
        <div class="klp-diag-field">
          <label class="klp-diag-field-label" for="klp-d-sex">性別</label>
          <select class="klp-diag-select" id="klp-d-sex">
            <option value="male">男性</option>
            <option value="female">女性</option>
          </select>
        </div>
        <div class="klp-diag-field">
          <label class="klp-diag-field-label" for="klp-d-nayami">お悩み</label>
          <select class="klp-diag-select" id="klp-d-nayami">
            <option value="no">特になし</option>
            <option value="pain">腰痛・肩こり対策</option>
            <option value="yokomuki">横向き寝中心</option>
            <option value="sorigoshi">反り腰</option>
            <option value="soft">柔らかめが好き</option>
          </select>
        </div>
      </div>
      <button class="klp-diag-submit" id="klp-d-submit">診 断 す る</button>
    `;
    overlay.querySelector('#klp-d-submit').addEventListener('click', () => {
      const h = parseInt(overlay.querySelector('#klp-d-height').value);
      const w = parseInt(overlay.querySelector('#klp-d-weight').value);
      const s = overlay.querySelector('#klp-d-sex').value;
      const n = overlay.querySelector('#klp-d-nayami').value;
      renderDiagResult(h, w, s, n);
    });
  }

  function renderDiagResult(height, weight, sex, nayami) {
    const result = calcDiagnosis(height, weight, sex, nayami);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'diagnosis_complete', nayami: nayami, weight: weight });
    const overlay = document.getElementById('klp-quiz-overlay');
    const body = overlay.querySelector('.klp-quiz-body');
    overlay.querySelector('.klp-quiz-step-label').textContent = '診断結果';
    const cell = n => `<div class="klp-diag-cell" data-n="${n}">${n}N</div>`;
    body.innerHTML = `
      <p class="klp-quiz-result-eyebrow">おすすめの配置</p>
      <div class="klp-diag-result-summary">
        ${sex === 'female' ? '女性' : '男性'} / ${height}cm / ${weight}kg<br>
        お悩み: ${NAYAMI_LABELS[nayami]}
      </div>
      <div class="klp-diag-grid">
        <div class="klp-diag-grid-head">
          <div class="klp-diag-grid-head-cell">頭〜肩</div>
          <div class="klp-diag-grid-head-cell">腰〜尻</div>
          <div class="klp-diag-grid-head-cell">もも〜脚</div>
        </div>
        <div class="klp-diag-grid-body">
          ${cell(result[0])}${cell(result[1])}${cell(result[2])}
          ${cell(result[3])}${cell(result[4])}${cell(result[5])}
        </div>
      </div>
      <div class="klp-diag-legend">
        <div class="klp-diag-legend-item">
          <div class="klp-diag-legend-dot" style="background:var(--ivory)"></div>70N やわ
        </div>
        <div class="klp-diag-legend-item">
          <div class="klp-diag-legend-dot" style="background:rgba(184,153,104,0.22)"></div>150N 中
        </div>
        <div class="klp-diag-legend-item">
          <div class="klp-diag-legend-dot" style="background:rgba(44,110,106,0.18)"></div>240N 硬め
        </div>
      </div>
      <p style="font-size:12px;color:var(--ivory-dim);line-height:1.7;margin-bottom:20px">まず配送時の状態でお試しいただき、合わない場合は上記の配置をお試しください。</p>
      <button class="klp-btn-navy" id="klp-d-buy" style="margin-bottom:10px">この配置で購入を進める</button>
      <button class="klp-diag-retry" id="klp-d-retry">もう一度診断する</button>
    `;
    body.querySelector('#klp-d-retry').addEventListener('click', renderDiagForm);
    body.querySelector('#klp-d-buy').addEventListener('click', () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'lp_cta_click', cta_label: 'diagnosis_buy' });
      closeQuiz();
      const sec = document.querySelector('.klp-section-products');
      if (sec) sec.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ── Firmness Configurator ── */
  function initConfigurator() {
    const container = document.querySelector('.klp-configurator');
    if (!container) return;

    const state = { head: 1, waist: 2, leg: 1 };
    const labels = { head: '頭まわり', waist: '腰まわり', leg: '脚まわり' };
    const hardness = ['やわ', '中', '硬'];

    const rows = container.querySelectorAll('.klp-config-row');
    rows.forEach(row => {
      const key = row.dataset.key;
      const btns = row.querySelectorAll('.klp-config-btn');
      btns.forEach((btn, idx) => {
        btn.addEventListener('click', () => {
          state[key] = idx;
          btns.forEach((b, bi) => b.classList.toggle('is-active', bi === idx));
          const valEl = row.querySelector('.klp-config-value');
          if (valEl) valEl.textContent = hardness[idx];
        });
      });
    });
  }

  /* ── Review Tabs ── */
  function initTabs() {
    document.querySelectorAll('.klp-tabs').forEach(tabsEl => {
      const tabs = tabsEl.querySelectorAll('.klp-tab');
      const container = tabsEl.parentElement;
      const panels = container.querySelectorAll('.klp-review-panel');

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => t.classList.remove('is-active'));
          panels.forEach(p => p.classList.remove('is-active'));
          tab.classList.add('is-active');
          panels[i].classList.add('is-active');
        });
      });
    });
  }

  /* ── FAQ Accordion ── */
  function initFAQ() {
    document.querySelectorAll('.klp-faq-item').forEach((item, i) => {
      const btn = item.querySelector('.klp-faq-q');
      btn.addEventListener('click', () => {
        const wasOpen = item.classList.contains('is-open');
        document.querySelectorAll('.klp-faq-item').forEach(el => el.classList.remove('is-open'));
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  /* ── Variant Price Update ── */
  function initVariantSelects() {
    document.querySelectorAll('.klp-variant-select').forEach(select => {
      const targetId = select.dataset.priceTarget;
      if (!targetId) return;
      select.addEventListener('change', () => {
        const opt = select.options[select.selectedIndex];
        const price = opt.dataset.price;
        const target = document.getElementById(targetId);
        if (target && price) {
          target.innerHTML = `¥${price}`;
        }
      });
    });
  }

  /* ── AJAX Add to Cart ── */
  let toastTimer;

  function showCartToast(productName, success, errorMsg) {
    const toast = document.getElementById('klp-cart-toast');
    if (!toast) return;
    if (success) {
      toast.innerHTML = `
        <div class="klp-cart-toast-msg"><span>${productName}</span> をカートに追加しました</div>
        <button class="klp-cart-toast-btn" onclick="location.href='/cart'">カートへ →</button>
      `;
    } else {
      toast.innerHTML = `<div class="klp-cart-toast-msg" style="color:rgba(245,241,232,0.8)">${errorMsg || '追加に失敗しました。再度お試しください。'}</div>`;
    }
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4000);
  }

  function initAddToCart() {
    document.querySelectorAll('.klp-btn-add-cart').forEach(btn => {
      btn.addEventListener('click', async () => {
        const inputId = btn.dataset.variantInput;
        const productName = btn.dataset.productName || '商品';
        const input = document.getElementById(inputId);
        if (!input) return;

        const variantId = input.tagName === 'SELECT'
          ? input.options[input.selectedIndex]?.value
          : input.value;

        if (!variantId) return;

        btn.classList.add('is-loading');
        const originalText = btn.textContent;
        btn.textContent = '追加中...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
          });
          const data = await res.json();
          if (res.ok && data.id) {
            showCartToast(productName, true);
            updateCartCount();
          } else {
            showCartToast(productName, false, data.description || data.message);
          }
        } catch (e) {
          showCartToast(productName, false);
        } finally {
          btn.classList.remove('is-loading');
          btn.textContent = originalText;
        }
      });
    });
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const badges = document.querySelectorAll('[data-cart-count]');
      badges.forEach(b => { b.textContent = cart.item_count; });
    } catch {}
  }

  /* ── Scroll Fade In ── */
  function initScrollFade() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('[data-fade]').forEach(el => observer.observe(el));
  }

  /* ── Init ── */
  function init() {
    // Quiz triggers
    document.querySelectorAll('[data-quiz-open]').forEach(el => {
      el.addEventListener('click', openQuiz);
    });
    const overlay = document.getElementById('klp-quiz-overlay');
    if (overlay) {
      overlay.querySelector('.klp-quiz-close').addEventListener('click', closeQuiz);
      overlay.addEventListener('click', e => { if (e.target === overlay) closeQuiz(); });
    }

    initConfigurator();
    initTabs();
    initFAQ();
    initScrollFade();
    initVariantSelects();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
